import { FC } from "react";
import { ImageBlock } from "@/api/generated-api";
import S from "./index.module.scss";
import Image from "next/image";

interface ITechnologyImage {
  data: ImageBlock;
}

const TechnologyImage: FC<ITechnologyImage> = ({ data }) => {
  return (
    <div className={S.wrapper}>
      {data.title && <p className={S.title}>{data.title}</p>}
      <Image className={S.styledImage} width={1360} height={900} src={data.image} alt={data.title ?? "image"} />
    </div>
  );
};

export default TechnologyImage;
